<div class="page-notfound">
  <div class="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-[#111827] via-[#1f2937] to-black text-white px-6 relative overflow-hidden">

    <!-- Background Glow -->
    <div class="absolute w-[500px] h-[500px] bg-amber-400/20 blur-3xl rounded-full top-[-100px] left-[-100px]"></div>
    <div class="absolute w-[400px] h-[400px] bg-blue-500/20 blur-3xl rounded-full bottom-[-100px] right-[-100px]"></div>

    <!-- Content -->
    <div class="text-center z-10 max-w-2xl">

      <!-- Code 404 -->
      <h1 class="tracking-widest text-amber-400 drop-shadow-lg animate-pulse animate-flicker">
        404
      </h1>

      <!-- Title -->
      <h2 class="text-3xl md:text-4xl font-semibold mt-4 text-white">
        {{ 'common.notFound.title' | transloco }}
      </h2>

      <!-- Description -->
      <p class="text-[#9ca3af] mt-4 text-lg">
        {{ 'common.notFound.detail' | transloco }}
      </p>

      <!-- Actions -->
      <div class="mt-8 flex flex-col sm:flex-row gap-4 justify-center">

        <a routerLink="/home"
          class="px-6 py-3 rounded-full bg-amber-400 text-gray-900 font-semibold shadow-md hover:bg-yellow-300 transition">
          {{ 'common.notFound.goToDashboard' | transloco }}
        </a>

      </div>

    </div>

    <!-- Decorative Machine Lines -->
    <div class="absolute inset-0 pointer-events-none">
      <div class="absolute top-1/2 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gray-600 to-transparent opacity-30"></div>
      <div class="absolute bottom-1/4 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gray-600 to-transparent opacity-30"></div>
    </div>

  </div>
</div>